import { Nullable } from "@/api/ApiClient";

export type ProviderInvoicePaymentFormData = Nullable<{
    id: string | undefined,
    monto: number,
    recibo: string,
    cobrador: string,
    forma_pago: string,
    reference: string,
    exchange_rate: number,
    descripcion: string,
    estado: string,
    created: string,
    digitosTarjeta: string,
    numAprobacion: string,
    creditOperatorId: string,
    providerRecibeId: string,
    bankAccountId: string,
    bankAccount: any,
    providerInvoiceId: string,
    providerInvoice: any,
    currencyId: string,
    currency: any
}>;

export const ProviderInvoicePaymentRelatedAttributes: Array<keyof ProviderInvoicePaymentFormData> = ["bankAccount", "providerInvoice", "currency"];
